export default "__VITE_ASSET__cca338f8__"